/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-mediaqueries-touchevents-setclasses !*/
!(function (e, n, t) {
    function o(e, n) {
        return typeof e === n;
    }

    function s() {
        var e, n, t, s, a, i, r;
        for (var l in d)
            if (Object.prototype.hasOwnProperty.call(d, l)) {
                if (
                    ((e = []),
                    (n = d[l]),
                    n.name &&
                        (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length))
                )
                    for (t = 0; t < n.options.aliases.length; t++) e.push(n.options.aliases[t].toLowerCase());
                for (s = o(n.fn, "function") ? n.fn() : n.fn, a = 0; a < e.length; a++)
                    (i = e[a]),
                        (r = i.split(".")),
                        1 === r.length
                            ? (Modernizr[r[0]] = s)
                            : (!Modernizr[r[0]] ||
                                  Modernizr[r[0]] instanceof Boolean ||
                                  (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])),
                              (Modernizr[r[0]][r[1]] = s)),
                        f.push((s ? "" : "no-") + r.join("-"));
            }
    }

    function a(e) {
        var n = c.className,
            t = Modernizr._config.classPrefix || "";
        if ((p && (n = n.baseVal), Modernizr._config.enableJSClass)) {
            var o = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
            n = n.replace(o, "$1" + t + "js$2");
        }
        Modernizr._config.enableClasses &&
            ((n += " " + t + e.join(" " + t)), p ? (c.className.baseVal = n) : (c.className = n));
    }

    function i() {
        return "function" != typeof n.createElement
            ? n.createElement(arguments[0])
            : p
              ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0])
              : n.createElement.apply(n, arguments);
    }

    function r() {
        var e = n.body;
        return e || ((e = i(p ? "svg" : "body")), (e.fake = !0)), e;
    }

    function l(e, t, o, s) {
        var a,
            l,
            f,
            d,
            u = "modernizr",
            p = i("div"),
            m = r();
        if (parseInt(o, 10)) for (; o--; ) (f = i("div")), (f.id = s ? s[o] : u + (o + 1)), p.appendChild(f);
        return (
            (a = i("style")),
            (a.type = "text/css"),
            (a.id = "s" + u),
            (m.fake ? m : p).appendChild(a),
            m.appendChild(p),
            a.styleSheet ? (a.styleSheet.cssText = e) : a.appendChild(n.createTextNode(e)),
            (p.id = u),
            m.fake &&
                ((m.style.background = ""),
                (m.style.overflow = "hidden"),
                (d = c.style.overflow),
                (c.style.overflow = "hidden"),
                c.appendChild(m)),
            (l = t(p, e)),
            m.fake
                ? (m.parentNode.removeChild(m), (c.style.overflow = d), c.offsetHeight)
                : p.parentNode.removeChild(p),
            !!l
        );
    }

    var f = [],
        d = [],
        u = {
            _version: "3.5.0",
            _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
            _q: [],
            on: function (e, n) {
                var t = this;
                setTimeout(function () {
                    n(t[e]);
                }, 0);
            },
            addTest: function (e, n, t) {
                d.push({ name: e, fn: n, options: t });
            },
            addAsyncTest: function (e) {
                d.push({ name: null, fn: e });
            },
        },
        Modernizr = function () {};
    (Modernizr.prototype = u), (Modernizr = new Modernizr());
    var c = n.documentElement,
        p = "svg" === c.nodeName.toLowerCase(),
        m = (function () {
            var n = e.matchMedia || e.msMatchMedia;
            return n
                ? function (e) {
                      var t = n(e);
                      return (t && t.matches) || !1;
                  }
                : function (n) {
                      var t = !1;
                      return (
                          l("@media " + n + " { #modernizr { position: absolute; } }", function (n) {
                              t =
                                  "absolute" ==
                                  (e.getComputedStyle ? e.getComputedStyle(n, null) : n.currentStyle).position;
                          }),
                          t
                      );
                  };
        })();
    (u.mq = m), Modernizr.addTest("mediaqueries", m("only all"));
    var h = u._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    u._prefixes = h;
    var v = (u.testStyles = l);
    Modernizr.addTest("touchevents", function () {
        var t;
        if ("ontouchstart" in e || (e.DocumentTouch && n instanceof DocumentTouch)) t = !0;
        else {
            var o = [
                "@media (",
                h.join("touch-enabled),("),
                "heartz",
                ")",
                "{#modernizr{top:9px;position:absolute}}",
            ].join("");
            v(o, function (e) {
                t = 9 === e.offsetTop;
            });
        }
        return t;
    }),
        s(),
        a(f),
        delete u.addTest,
        delete u.addAsyncTest;
    for (var y = 0; y < Modernizr._q.length; y++) Modernizr._q[y]();
    e.Modernizr = Modernizr;
})(window, document);
